module.exports = __webpack_public_path__ + "img/icon1.40b2b3dc.png";